import { gql } from "@apollo/client";

export const GET_PEOPLE_WITH_MAILING_ADDRESS = gql`
  query GET_ADDRESS($addressId: ID!, $originatorId: ID!) {
    getAddress(addressId: $addressId, originatorId: $originatorId) {
      id
      associatedPeople {
        mailing {
          aliases {
            id
            target {
              id
              validPersonAlerts {
                alertType {
                  name
                  alertLevel
                }
              }
            }
          }
          id
          personalAttribute {
            lastName
            firstName
            middleName
            mailingAddress {
              name
            }
            dob
            phone
          }
          validPersonAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
          }
        }
      }
    }
  }
`;
